import type { FC } from "react";
import type { FileWithThumbnail } from "../types";
import FilePreview from "./FilePreview";
import MediaPreview from "./MediaPreview";

type Props = {
  files: readonly File[];
  allowMultipleDocumentsPreview?: boolean;
};

const hasNonThumbnailFile = (files: readonly File[]) =>
  files.some(
    (file) =>
      !["image/", "video/"].some((s) => {
        return file.type.startsWith(s);
      }),
  );

const Preview: FC<Props> = ({ files, allowMultipleDocumentsPreview = false }) => {
  if (!hasNonThumbnailFile(files)) {
    return <MediaPreview files={files} />;
  }

  const mediaFiles = files.filter((file) => ["image/", "video/"].some((type) => file.type.startsWith(type)));
  const documentFiles = files.filter((file) => !mediaFiles.includes(file));
  const filesToPreview = allowMultipleDocumentsPreview ? documentFiles : documentFiles.slice(0, 1);

  return (
    <>
      {mediaFiles.length > 0 ? <MediaPreview files={mediaFiles} /> : null}
      <div>
        {filesToPreview.map((file) => (
          <FilePreview key={`${file.name}-${file.lastModified}`} file={file as FileWithThumbnail} />
        ))}
      </div>
    </>
  );
};
export default Preview;
